import React from 'react';

const PrivacyPolicyPage = () => {
    const QnA = {
        "What information do we collect?":
            "We may collect personal information such as your name, email address, shipping and billing address, phone number, account details, order history, and any information you provide when contacting us. We also collect certain technical data automatically, including IP address, browser type, device information, and site usage data.",

        "How do we collect personal information?":
            "We collect information when you create an account, place an order, contact us, submit forms, or interact with our website. Some information is also collected automatically through cookies and similar tracking technologies when you browse the site.",

        "How do we use your information?":
            "Your personal information is used to operate our services, process orders and payments, provide customer support, communicate updates, improve our website experience, prevent fraud, and comply with legal obligations.",

        "Do we store payment details?":
            "No. All payments are processed securely by trusted third-party payment providers. We do not store or have access to your full payment card details.",

        "Do we use cookies?":
            "Yes. We use cookies and similar technologies to enable essential site functionality, remember preferences, analyse traffic, and improve performance. You can disable cookies through your browser settings, although some features of the site may not function properly.",

        "Who do we share information with?":
            "We may share personal information with third-party service providers such as payment processors, shipping partners, website hosting services, analytics providers, and professional advisers. We only share information that is reasonably necessary for these services.",

        "Is my information shared overseas?":
            "Some service providers may store or process data outside Australia. We take reasonable steps to ensure any overseas handling of personal information is consistent with Australian privacy standards.",

        "How do we protect your data?":
            "We take reasonable technical and organisational measures to protect personal information from misuse, loss, unauthorised access, or disclosure. However, no system is completely secure, and we cannot guarantee absolute data security.",

        "How long do we keep your information?":
            "We retain personal information only for as long as necessary to fulfil the purposes outlined in this policy or to meet legal, accounting, or regulatory requirements.",

        "Can I access or correct my personal information?":
            "Yes. You may request access to the personal information we hold about you or request corrections if information is inaccurate or outdated. Requests can be made by contacting us directly.",

        "Do we send marketing communications?":
            "We may send marketing communications if you choose to opt in. You can unsubscribe at any time by following the instructions in our communications or by contacting us.",

        "Third-party links":
            "Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those websites.",

        "Changes to this privacy policy":
            "We may update this Privacy Policy from time to time. Any changes will be posted on this page and take effect from the date of publication.",

        "How can I contact you about privacy?":
            "If you have any questions, concerns, or requests regarding your personal information or this Privacy Policy, please contact us at avgpokecollector@gmail.com."
    };


  return (
    <div className='qna hide-scrollbar'>
      {Object.entries(QnA).map(([question, answer], index) => (
        <div key={index} className='bottom-margin'>
          <h1 className='question no-margin'>{question}</h1>
          <div className='answer no-margin'>{answer}</div>
        </div>
      ))}
    </div>
  );
};

export default PrivacyPolicyPage;
